export function detectPWAMode() {
  const result = {
    displayMode: 'browser',
    isPWA: false,
  };

  // window.navigator.standalone - check iOS Safari standalone mode
  if (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true) {
    result.displayMode = 'standalone';
  } else if (window.matchMedia('(display-mode: fullscreen)').matches) {
    result.displayMode = 'fullscreen';
  } else if (window.matchMedia('(display-mode: minimal-ui)').matches) {
    result.displayMode = 'minimal-ui';
  }

  result.isPWA = result.displayMode === 'standalone' || result.displayMode === 'fullscreen';

  return result;
}

export function detectDevice() {
  const checks = {
    ...detectPWAMode(),
    isAndroid: false,
    isIOS: false,
    isMobile: false,
    isWebShareAvailable: !!navigator.canShare,
  };

  // Check for touch capability
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check screen size
  const isSmallScreen = window.screen.width <= 768 || window.innerWidth <= 768;

  // Check for mobile-specific APIs
  const hasMobileAPIs = 'orientation' in window || 'DeviceOrientationEvent' in window;

  // Check CSS media queries for mobile interaction patterns
  const mobileMediaQuery = window.matchMedia('(hover: none) and (pointer: coarse)');
  const touchMediaQuery = window.matchMedia('(any-pointer: coarse)');

  checks.isMobile = hasTouch && (isSmallScreen || mobileMediaQuery.matches || hasMobileAPIs || touchMediaQuery.matches);

  // iOS detection using modern methods
  checks.isIOS =
    // Check for iOS-specific standalone property
    (window.navigator as any).standalone !== undefined ||
    // Check for iOS-specific touch behavior
    (hasTouch &&
      navigator.maxTouchPoints > 1 &&
      /Safari/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent)) ||
    // Check for iOS-specific CSS support
    CSS.supports('-webkit-touch-callout', 'none') ||
    // Check for iOS-specific media query
    window.matchMedia('(-webkit-touch-callout: none)').matches;

  // Android detection using modern methods
  checks.isAndroid =
    checks.isMobile &&
    !checks.isIOS &&
    // Check for Android-specific user agent (still most reliable for Android)
    (/Android/i.test(navigator.userAgent) ||
      // Check for Android-specific features
      ('connection' in navigator && navigator.connection && (navigator as any).connection.type) ||
      // Check for Android Chrome specific behavior
      (hasTouch && /Chrome/.test(navigator.userAgent) && !(window.navigator as any).standalone));

  return checks;
}

export const isObject = (value: any) => typeof value === 'object' && value !== null;
